import type { ScheduleRow } from '@app/shared';
import { formatCents, formatIsoDate } from '@/lib/format';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

export function ScheduleTable({ rows, currency }: { rows: readonly ScheduleRow[]; currency: string }) {
  return (
    <div className="max-h-[32rem] overflow-y-auto rounded-xl border border-border bg-card">
      <Table>
        <TableHeader className="sticky top-0 bg-card">
          <TableRow>
            <TableHead>#</TableHead>
            <TableHead>Échéance</TableHead>
            <TableHead className="text-right">Capital</TableHead>
            <TableHead className="text-right">Intérêts</TableHead>
            <TableHead className="text-right">Assurance</TableHead>
            <TableHead className="text-right">Mensualité</TableHead>
            <TableHead className="text-right">Capital restant dû</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.installment}>
              <TableCell>{row.installment}</TableCell>
              <TableCell>{formatIsoDate(row.dueDate)}</TableCell>
              <TableCell className="text-right">{formatCents(row.principalCents, currency)}</TableCell>
              <TableCell className="text-right">{formatCents(row.interestCents, currency)}</TableCell>
              <TableCell className="text-right">{formatCents(row.insuranceCents, currency)}</TableCell>
              <TableCell className="text-right font-medium">{formatCents(row.paymentCents, currency)}</TableCell>
              <TableCell className="text-right">{formatCents(row.balanceCents, currency)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
